import React, { useState, useEffect } from "react"
import { FaArrowLeft, FaArrowRight } from "react-icons/fa"
import TestimonialCard from "./card/TestimonialCard"
import { gsap, Power3 } from "gsap"

export default function Testimonial({ data }) {
  const [action, setAction] = useState(0)

  useEffect(() => {
    const slot = gsap.utils.toArray(".slide")
    if (slot.length - 1 < action) {
      setAction(0)
    } else if (action - 1 < 0) {
      setAction(0)
    }

    gsap.to(slot, {
      duration: 0.3,
      x: -slot[0].offsetWidth * action,
      ease: Power3.easeOut,
    })
    // console.log(slot.length, slot[0].offsetWidth, action)
  }, [action])

  return (
    <section className="pb-12 md:pb-20 w-[95%] max-w-7xl ml-auto">
      <div className="bg-[#F5F2EE] border border-[#E7C8A2] pl-6 py-12 md:py-20">
        <div className="grid gap-2 md:gap-0 md:flex md:space-x-5">
          <div className="md:w-3/12 ">
            <div>
              <h2 className="text-xl md:text-3xl font-bold">
                What our clients are saying
              </h2>
              <p className="max-w-2xl mx-auto text-xs py-4">
                We built in trust with our clients and owners, more than a
                transactions we create connections with people, we create a big
                family in Ibiza. Here is a sample of how they show us their love
                and admiration.
              </p>
            </div>
            <div className="flex space-x-2">
              <button
                disabled={action <= 0 ? true : false}
                onClick={() => setAction(action => action - 1)}
                className={` text-white rounded px-8 py-3 ${
                  action <= 0 ? "bg-stone-800 cursor-not-allowed" : "bg-black"
                }`}
              >
                <FaArrowLeft />
              </button>
              <button
                onClick={() => setAction(action => action + 1)}
                className="bg-black rounded text-white px-8 py-3"
              >
                <FaArrowRight />
              </button>
            </div>
          </div>
          <div className="md:w-9/12 overflow-hidden relative pl-4 pb-12">
            <div className="relative flex items-center h-96 lg:h-72 ">
              <div
                id="wrapper"
                className="absolute top-0 left-0 h-full w-full flex justify-center space-x-3 min-w-max"
              >
                {data.map((c, key) => {
                  return (
                    <TestimonialCard
                      id="slide"
                      // reff={slideRef}
                      author={c.node.client_name}
                      comment={c.node.testimonial}
                      position={c.node.client_position}
                      location={c.node.client_country}
                      key={key}
                    />
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
